import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./app/organisms/Login";
import ForgotPassword from "./app/organisms/ForgotPassword";
import UpdatePassword from "./app/organisms/UpdatePassword";
import { isLoggedIn } from "./app/config/utils"; // Adjust path if needed
import Dashboard from "./app/organisms/Dashboard";
import NoPermission from "./app/organisms/NoPermission";
import UI from "./app/organisms/UI";
import Home from "./app/organisms/Home";
import MyProfile from "./app/organisms/MyProfile";
import Companies from "./app/organisms/Company";
import CreateCompany from "./app/organisms/Company/CreateCompany";
import AddTeamMember from "./app/organisms/Team/AddTeamMember";
import AdminTeam from "./app/organisms/Team";
import CustomerUsers from "./app/organisms/Users";
import EditUser from "./app/organisms/Users/EditUser";
import EditCompany from "./app/organisms/Company/EditCompany";
import CreateUser from "./app/organisms/Users/CreateUser";
import EditTeamMember from "./app/organisms/Team/EditTeamMember";
import CompanySettings from "./app/organisms/CompanySettings";
import CompanyDetails from "./app/organisms/CompanySettings/Details";
import Employees from "./app/organisms/CompanySettings/Employees";
import AddEmployee from "./app/organisms/CompanySettings/Employees/AddEmployee";
import CrewYards from "./app/organisms/CompanySettings/CrewYards";
import AddCrewYards from "./app/organisms/CompanySettings/CrewYards/AddCrewYards";
import EditEmployee from "./app/organisms/CompanySettings/Employees/EditEmployee";
import EditCrewYards from "./app/organisms/CompanySettings/CrewYards/EditCrewYards";
import Inventory from "./app/organisms/Inventory";
import AddMaterials from "./app/organisms/Inventory/Components/Materials/AddMaterials";
import AddEquipment from "./app/organisms/Inventory/Components/Equipment/AddEquipment";
import EditMaterials from "./app/organisms/Inventory/Components/Materials/EditMaterials";
import EditEquipment from "./app/organisms/Inventory/Components/Equipment/EditEquipment";
import LaborHourlyRates from "./app/organisms/CompanySettings/LabourHourlyRates";
import TagsCategories from "./app/organisms/CompanySettings/TagsCategories";
import UploadMaterials from "./app/organisms/Inventory/Components/Materials/BulkUpload";
import UploadEquipment from "./app/organisms/Inventory/Components/Equipment/BulkUpload";
import UploadCrewYards from "./app/organisms/CompanySettings/CrewYards/BulkUpload";
import TakeoffMeasurements from "./app/organisms/CompanySettings/TakeoffMeasurements";
import MeasurementsUnits from "./app/organisms/CompanySettings/MeasurementsUnits";
import Services from "./app/organisms/CompanySettings/Services";
import CreateServiceLine from "./app/organisms/CompanySettings/Services/CreateServiceLine";
import Clients from "./app/organisms/Clients";
import AddClient from "./app/organisms/Clients/AddClient";
import EditClient from "./app/organisms/Clients/EditClient";
import AddService from "./app/organisms/CompanySettings/Services/AddService";
import Custom from "./app/organisms/CompanySettings/Services/CreateServiceLine/Custom";
import ServiceDetails from "./app/organisms/CompanySettings/Services/ServiceDetails";
import AddSubService from "./app/organisms/CompanySettings/Services/AddService/AddSubService";
import Properties from "./app/organisms/Properties";
import AddProperty from "./app/organisms/Properties/AddProperty";
import EditService from "./app/organisms/CompanySettings/Services/EditService";
import EditServiceLine from "./app/organisms/CompanySettings/Services/EditServiceLine";
import EditSubService from "./app/organisms/CompanySettings/Services/EditService/EditSubService";
import Crews from "./app/organisms/CrewsSubs/Crews";
import Subs from "./app/organisms/CrewsSubs/Subs";
import AddSubcontractor from "./app/organisms/CrewsSubs/Subs/AddSubcontractor";
import EditSubcontractor from "./app/organisms/CrewsSubs/Subs/EditSubcontractor";
import AddCrews from "./app/organisms/CrewsSubs/Crews/AddCrews";
import EditCrews from "./app/organisms/CrewsSubs/Crews/EditCrews";
import EditProperty from "./app/organisms/Properties/EditProperty";
import PotentialDeals from "./app/organisms/PotentialDeals";
import CreateDeal from "./app/organisms/PotentialDeals/CreateDeal";
import CreateNewDeal from "./app/organisms/PotentialDeals/CreateNewDeal";
import DealsDetail from "./app/organisms/PotentialDeals/DealsDetail";
import Estimate from "./app/organisms/PotentialDeals/Estimates";
import EditDeal from "./app/organisms/PotentialDeals/EditDeal";
import DocumentEditor from "./app/organisms/PotentialDeals/DocumentEditor";
import AddTask from "./app/organisms/WorkOrders/Tasks/AddTask";
import Tasks from "./app/organisms/WorkOrders/Tasks";
import WorkOrders from "./app/organisms/WorkOrders";
import TransferProperty from "./app/organisms/Properties/TransferProperty";
import WorkOrderReport from "./app/organisms/WorkOrders/WorkOrderReport";
import Scheduling from "./app/organisms/Scheduling";
import RoutesMap from "./app/organisms/Scheduling/Component/KanbanBoard/Routes";
import ScheduleWork from "./app/organisms/Scheduling/ScheduleWork";
import PropertyProfile from "./app/organisms/Properties/Profile";
import ClientProfile from "./app/organisms/Clients/Profile";
import CrewsProfile from "./app/organisms/CrewsSubs/Crews/Profile";
import SubsProfile from "./app/organisms/CrewsSubs/Subs/Profile";
import ProposalBuilder from "./app/organisms/PotentialDeals/ProposalBuilder";
import Contracts from "./app/organisms/Contracts";
import ContractDetails from "./app/organisms/Contracts/ContractDetails";

export const AppRoutes = () => {
  const auth = isLoggedIn();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/ui" element={<UI />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/update-password" element={<UpdatePassword />} />
      {auth ? (
        <>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/my-profile/:id" element={<MyProfile />} />
          <Route path="/create-company" element={<CreateCompany />} />
          <Route path="/edit-company/:id" element={<EditCompany />} />
          <Route path="/add-team-member" element={<AddTeamMember />} />
          <Route path="/admin-team" element={<AdminTeam />} />
          <Route path="/customer-users" element={<CustomerUsers />} />
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/edit-user/:id" element={<EditUser />} />
          <Route path="/edit-team-member/:id" element={<EditTeamMember />} />
          <Route path="/no-permission" element={<NoPermission />} />
          <Route path="/inventory/:id/:id" element={<Inventory />} />
          <Route path="/add-materials/:id" element={<AddMaterials />} />
          <Route path="/upload-materials/:id" element={<UploadMaterials />} />
          <Route path="/upload-equipment/:id" element={<UploadEquipment />} />
          <Route path="/add-equipment/:id" element={<AddEquipment />} />
          <Route path="/edit-materials/:id/:id" element={<EditMaterials />} />
          <Route path="/edit-equipment/:id/:id" element={<EditEquipment />} />
          <Route path="/clients/:id" element={<Clients />} />
          <Route path="/add-client/:id" element={<AddClient />} />
          <Route path="/edit-client/:id/:id" element={<EditClient />} />
          <Route path="/properties/:id" element={<Properties />} />
          <Route path="/add-property/:id" element={<AddProperty />} />
          <Route path="/edit-property/:id/:id" element={<EditProperty />} />
          <Route path="/transfer-property/:id" element={<TransferProperty />} />
          <Route
            path="/properties/profile/:id/:id"
            element={<PropertyProfile />}
          />
          <Route path="/clients/profile/:id/:id" element={<ClientProfile />} />
          <Route path="/crews/profile/:id" element={<CrewsProfile />} />
          <Route path="/subcontractor/profile/:id" element={<SubsProfile />} />
          <Route
            path="/company-settings/takeoff-measurements/:id"
            element={<TakeoffMeasurements />}
          />
          <Route
            path="/company-settings/measurements-units/:id"
            element={<MeasurementsUnits />}
          />
          <Route
            path="/company-settings/labor-hourly-rates/:id"
            element={<LaborHourlyRates />}
          />
          <Route
            path="/company-settings/tags-categories/:id/"
            element={<TagsCategories />}
          />
          <Route path="/company-settings/:id" element={<CompanySettings />} />
          <Route
            path="/company-settings/details/:id"
            element={<CompanyDetails />}
          />
          <Route
            path="/company-settings/employees/:id"
            element={<Employees />}
          />
          <Route
            path="/company-settings/add-employee/:id"
            element={<AddEmployee />}
          />
          <Route
            path="/company-settings/edit-employee/:id/:id"
            element={<EditEmployee />}
          />
          <Route
            path="/company-settings/crew-yards/:id"
            element={<CrewYards />}
          />
          <Route
            path="/company-settings/add-crew-yard/:id"
            element={<AddCrewYards />}
          />
          <Route
            path="/company-settings/upload-crew-yard/:id"
            element={<UploadCrewYards />}
          />
          <Route
            path="/company-settings/edit-crew-yard/:id/:id"
            element={<EditCrewYards />}
          />
          <Route path="/company-settings/services/:id" element={<Services />} />
          <Route
            path="/company-settings/service-lines/:id/:id"
            element={<ServiceDetails />}
          />
          <Route
            path="/company-settings/create-service-line/:id"
            element={<CreateServiceLine />}
          />
          <Route
            path="/company-settings/edit-service-line/:id/:id"
            element={<EditServiceLine />}
          />
          <Route
            path="/company-settings/add-service/:id/:id"
            element={<AddService />}
          />
          <Route
            path="/company-settings/edit-service/:id/:id/:id"
            element={<EditService />}
          />
          <Route
            path="/company-settings/:id/:id/:id"
            element={<AddSubService />}
          />
          <Route
            path="/company-settings/:id/:id/:id/:id"
            element={<EditSubService />}
          />
          <Route
            path="/company-settings/custom-service/:id"
            element={<Custom />}
          />
          <Route path="/crews/:id" element={<Crews />} />
          <Route path="/subs/:id" element={<Subs />} />
          <Route path="/add-subcontractor/:id" element={<AddSubcontractor />} />
          <Route
            path="/edit-subcontractor/:id/:id"
            element={<EditSubcontractor />}
          />
          <Route path="/add-crews/:id" element={<AddCrews />} />
          <Route path="/edit-crews/:id/:id" element={<EditCrews />} />

          <Route path="/potential-deals/:id" element={<PotentialDeals />} />
          <Route path="/create-deal/:id" element={<CreateDeal />} />
          <Route path="/create-new-deal/:id" element={<CreateNewDeal />} />
          <Route path="/edit-deal/:id/:id" element={<EditDeal />} />
          <Route path="/deals-detail/:id/:id" element={<DealsDetail />} />
          <Route path="/estimate/:id/:id" element={<Estimate />} />
          <Route path="/edit-estimate/:id/:id/:id" element={<Estimate />} />
          <Route path="/editor/:id/:id/:id" element={<DocumentEditor />} />
          <Route path="/proposal-builder/:id" element={<ProposalBuilder />} />

          <Route path="/work-orders/:id" element={<WorkOrders />} />
          <Route path="/tasks/:id" element={<Tasks />} />
          <Route path="/new-task/:id" element={<AddTask />} />
          <Route path="/wo-report/:id" element={<WorkOrderReport />} />
          <Route path="/scheduling/:id" element={<Scheduling />} />
          <Route path="/route/:id" element={<RoutesMap />} />
          <Route path="/scheduler/:id" element={<ScheduleWork />} />

          <Route path="/contracts/:id" element={<Contracts />} />
          <Route path="/contracts/profile/:id" element={<ContractDetails />} />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
};
